var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container-fluid"},[_c('div',[_c('h4',{staticClass:"nes blue"},[_vm._v("Not found")]),_c('div',{staticClass:"mt2"},[_vm._v("How do you make "),_c('q',[_vm._v("one")]),_vm._v(" vanish?")]),_c('div',{staticClass:"text-muted mt-1"},[_vm._v("Prepend "),_c('q',[_vm._v("g")]),_vm._v(" and it's gone.")])])])
}]

export { render, staticRenderFns }